import React, {Component} from 'react';
import './userControl.css';
import FontAwesome from 'react-fontawesome';
import TextField from '@material-ui/core/TextField';
import {alertLabels, formTitles, labels, marketTypes, messages, profileTypes} from "../../util/constants";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import renderIf from 'render-if';
import {
    removeAllSpecialCharacters,
    removeSpecialCaracters,
    validatePlateArgentina,
    validatePlateBrazil
} from "../../util/tools";
import {routes} from "../../util/config";
import {setAlertOnRedux, setAlertOnReduxWithTime} from "../../actions";
import Car from "../../modules/Models/Car";
import User from "../../modules/Models/User";
import {Col, Row} from "reactstrap";
import httpHttpsRequest from '../../util/http-request/request';
import { getVehicleOptions, postUserOptions, getUsersOptions } from '../../util/optionsRequest';

class UserControl extends Component{
    constructor(props) {
        super(props);

        this.fromRef = React.createRef();

        if (this.props.location != null &&
            this.props.location.state != null &&
            this.props.location.state.detail != null) {
            let userData = this.props.location.state.detail;

            this.state = {
                edition:true,
                name: userData.user_name,
                userId: userData.id_user,
                user:{},
                userLocked: true,
                userValid:false,
                userError: false,
                profile: userData.profile_type,
                profileError: false,
                market: userData.market,
                marketError: false,
                car:'',
                plateError: false,
                plateErrorMessage: '',
                userErrorMessage:'',
                carList: this.objectToCarList(userData.carList),
                license_plate:'',
                showPlate: !this.isRadarProfile(userData.profile_type) && !userData.market=='' ,
            }
        }
        else {
            this.state = {
                name: '',
                userId: '',
                user:{},
                userLocked: false,
                userValid:false,
                userError: false,
                profile: '',
                profileError: false,
                market: '',
                marketError: false,
                car:'',
                plateError: false,
                plateErrorMessage: '',
                userErrorMessage:'',
                carList: [],
                showPlate: false,
                license_plate:''
            }
        }
        this.initialState = this.state;
    }

    componentWillMount(){
        //clean parameters, refresh when the page appears clean
        let stateParams = this.props.location.state;
        let empty = {};
        this.props.history.replace({...stateParams, empty });

        if(this.state.edition)
            this.searchUser();

    };

    findUser = (event) => {
        if (event.key === 'Enter') {
            this.searchUser();
        }
    };

    findCar = (event) => {
        if (event.key === 'Enter') {
            this.addCar();
        }
    };

    changeUser = (userField) => {

        if(userField.target.value.length<=10) {

            this.setState({
                userError: false,
                userErrorMessage: '',
            });

            userField.target.value =  removeSpecialCaracters(userField.target.value);

            let newUserID =userField.target.value.toUpperCase();
            this.setState({userId: newUserID});
        }
    };

    changeProfile = (profile) => {
        this.setState({
            profile: profile.target.value, showPlate: !this.isRadarProfile(profile.target.value) && this.state.market!='',
        });
    };

    isRadarProfile = (profile) =>{
        return profile == profileTypes.radar;
    };

    changeMarket = (market) => {
        let carList = (market.target.value === this.state.market) ? this.state.carList : [];
        this.setState({
            market: market.target.value,
            marketError:market.target.value==='',
            carList : carList,
            showPlate: !this.isRadarProfile(this.state.profile) && this.state.profile!='' &&  market.target.value!=''
        });
    };

    addCar = () => {

        let errorMessage = '';

        let plateValid = false;
        if (this.state.market === '') {
            errorMessage = messages.selectMarket;
        }
        else if (this.state.market === marketTypes.argentina) {
            plateValid = validatePlateArgentina(this.getLicensePlateFromState());
        }
        else if (this.state.market === marketTypes.brazil) {
            plateValid = validatePlateBrazil(this.getLicensePlateFromState());
        }
        if (!plateValid) errorMessage = messages.plateInvalid;

        this.setState({
            plateError: (!plateValid),
            plateErrorMessage: errorMessage,
        });

        if (!plateValid) return;


        let car = new Car();
        car.setLicensePlate(this.getLicensePlateFromState());

        if(!this.verifyIfCarIsDuplicated(car)) {
            let params = {
                license_plate: this.getLicensePlateFromState()
            };
            let http = new httpHttpsRequest(getVehicleOptions);
            http.addQueryString(params);
            http.makeRequest()
                .then(result => {

                    if(result!= undefined) {
                        result = JSON.parse(result);

                        if (!result.success) {
                            this.setState({
                                plateError: true,
                                plateErrorMessage: result.message,
                            });
                        } else {
                            let car = result.data;
                            this.changeCar(car);
                        }
                    }else{
                        Promise.reject('');
                    }

                }).catch(() => setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger));
        }else{
            this.setState({
                plateError: true,
                plateErrorMessage: messages.licensePlateAlreadyInserted,
            });

        }

    };

    getInitialCar=()=>{
        let car = new Car();
        car.setModelCar('');
        car.setLicensePlate('');
        return car;
    };

    getCar=()=>{
        return new Car(this.state.car);
    };

    getLicensePlateFromState=()=>{
        return this.state.license_plate;
    };


    verifyIfCarIsDuplicated=(car)=>{
        let list = this.state.carList;

        for(var i = list.length - 1; i >= 0; i--) {
            let itemCar = new Car(list[i]);
            if(itemCar.getLicensePlate() == car.getLicensePlate()) {
                this.setState({ car: this.getInitialCar()});
                return true;
            }
        }
        return false;
    };

    changeCar = (car) => {

        let carInfo = new Car(car);
        this.setState({car: carInfo});
        let list = this.state.carList;
        list.push(this.getCar());

        this.setState({ carList: list, car: this.getInitialCar(), license_plate:''});
    };

    changePlate=(license_plate)=>{

        if(license_plate.target.value.length<=7) {

            this.setState({
                plateError: false,
                plateErrorMessage: '',
            });

            license_plate.target.value = removeSpecialCaracters(license_plate.target.value);
            let newPlate = license_plate.target.value.toUpperCase();
            newPlate = removeAllSpecialCharacters(newPlate);
            this.setState({license_plate: newPlate});
        }

    };

    deleteCar = (car) => {
        let newList = this.state.carList;

        for(var i = newList.length - 1; i >= 0; i--) {

            if(newList[i].getLicensePlate() ==car.getLicensePlate()) {
                newList.splice(i, 1);
                break;
            }
        }

        this.setState({
            carList: newList
        });
    };

    generatePlates = () => {
        if(this.state.carList && this.state.carList.length > 0){
            return this.state.carList.map(car => {
                car = new Car(car);
                return(  <ListItem>
                        <ListItemText
                            primary={car.getLicensePlate()}
                            secondary={car.getModelCar() + (car.getColor()!=null?' '+ car.getColor():'')}
                        />
                        <ListItemSecondaryAction>
                            <IconButton
                                aria-label="Delete"
                                onClick={() => {
                                    this.deleteCar(car)
                                }}
                            >
                                <DeleteIcon/>
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                )
            });
        }
    };

    saveUser = () => {
        let userError = (this.state.userId === '');
        let profileError = (this.state.profile === '');
        let marketError = (this.state.market === '');
        let plateError = (!this.isRadarProfile(this.state.profile) && (this.state.carList == [] || this.state.carList.length  == 0) );

        this.setState({
            userError: userError,
            profileError: profileError,
            marketError: marketError,
            plateError: plateError
        });
        if (!(userError || profileError || marketError || plateError)) {

            let params = {
                id_user: this.state.userId.toUpperCase(),
                user:this.state.user,
                profile_type: this.state.profile,
                market: this.state.market,
            };

            if(!this.isRadarProfile(this.state.profile))
                params.carList=this.state.carList;

            let http = new httpHttpsRequest(postUserOptions);
            http.addRequestBody(params);
            http.makeRequest().then((data)=>{this.userSaved(data)})
                .catch((data)=>{this.userSaveError(data)})
        }
    };

    userSaved = () => {
        setAlertOnReduxWithTime(true, alertLabels.iconSuccess, messages.userSaved, alertLabels.alertSuccess,3000);
        this.setState({...this.initialState});

        if(this.state.edition)
            this.props.history.push(routes.users);
    };

    userSaveError = (response) => {
        try {
            let data = JSON.parse(response.body);
            setAlertOnRedux(true, alertLabels.iconError, data.message, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    searchUser = () =>{

        let userError = (this.state.userId === '');

        this.setState({
            userError: userError
        });

        if(!userError) {

            let params = {
                id_user: this.state.userId.toUpperCase()
            };

            let http = new httpHttpsRequest(getUsersOptions);
            http.addQueryString(params);
            http.makeRequest()
                .then(data => {
                    let result = JSON.parse(data);


                    if (result.success && result.data != undefined) {

                        if (result.data.length > 0) {
                            result.data = result.data[0];
                        }

                        let user = new User(result.data);
                        this.setState({
                            userId: user.getIdUser(),
                            user: user,
                            userValid: true,
                            userError: false,
                            userErrorMessage: ''
                        });

                    } else {
                        this.setState({
                            userValid: false,
                            userError: true,
                            userErrorMessage: messages.userInvalid
                        });
                    }

                })
                .catch(data => {
                    alert('ERRO' + JSON.stringify(data));
                    setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault, alertLabels.alertDanger)
                });
        }
    };

    cancel = () => {
        if (window.confirm(messages.cancelEdit))
            this.props.history.goBack();
    };

    verifyIfCanSave(){

        let userError = (!this.state.userValid);
        let profileError = (this.state.profile === '');
        let marketError = (this.state.market === '');
        let plateError = (!this.isRadarProfile(this.state.profile) && (this.state.carList == [] || this.state.carList.length  == 0) );

        return !(userError && profileError && marketError && plateError);
    };

    objectToCarList = (carList) =>{
        let list = [];
        if(carList && carList.length > 0){
            carList.map((carObject)=>{
                let car = new Car(carObject);
                list.push(car);
            });
            return list;
        }else{
            return carList;
        }
    };

    render() {
        let user = new User(this.state.user);

        return(
            <div className='container userControl'>
                <h1 className='title'><FontAwesome name={'user'}/>{'\u00A0'} {labels.userRegistration}</h1>
                <div ref={this.fromRef} className={'form'}>

                    <div className={'componentDiv'}>
                        <div className={'textInput'}>
                            <TextField
                                onKeyPress={this.findUser}
                                required={true}
                                label={labels.registration}
                                value={this.state.userId}
                                onChange={this.changeUser}
                                error={this.state.userError}
                                disabled={this.state.userLocked === true}
                                margin="normal"
                            />
                        </div>
                        {renderIf(!this.state.edition)(
                            <Button variant="contained" color="primary" onClick={this.searchUser}>
                                {labels.search}
                            </Button>
                        )}
                        {
                            renderIf(this.state.userError)(
                                <FormHelperText error={this.state.userError} className="plateErrorMessage">{this.state.userErrorMessage}</FormHelperText>
                            )
                        }

                        {renderIf(this.state.userValid)( <div className={'textInput'}>
                            <Row className="row-user">
                                <Col>
                                    <TextField
                                        disabled={true}
                                        label={labels.userRegister}
                                        value={user.getUserRegister()}
                                        margin="normal"
                                    />
                                </Col>
                                <Col>
                                    <TextField
                                        disabled={true}
                                        label={labels.userName}
                                        value={user.getUserName()}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                            <Row className="row-user">
                                <Col>
                                    <TextField
                                        disabled={true}
                                        label={labels.userEmail}
                                        value={user.getUserEmail()}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                            <Row className="row-user">
                                <Col>
                                    <TextField
                                        disabled={true}
                                        label={labels.userCResp}
                                        value={user.getUserCResp()}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                            </div>
                        )}

                    </div>

                    {renderIf(this.state.userValid)(
                        <div className={'componentDiv'}>
                            <FormLabel
                                required={true}
                                className={'formTitle'}
                                error={this.state.marketError}
                            >{formTitles.market}</FormLabel>

                            <RadioGroup
                                className='radioButton'
                                value={this.state.market}
                                onChange={this.changeMarket}
                            >
                                <FormControlLabel value={marketTypes.argentina} control={<Radio />} label={marketTypes.argentina} />
                                <FormControlLabel value={marketTypes.brazil} control={<Radio />} label={marketTypes.brazil} />
                            </RadioGroup>
                        </div>
                    )}
                    {renderIf(this.state.userValid)(
                        <div className={'componentDiv'}>
                            <FormLabel
                                required={true}
                                className={'formTitle'}
                                error={this.state.profileError}
                            >{formTitles.profile}</FormLabel>

                            <RadioGroup
                                className='radioButton'
                                value={this.state.profile}
                                onChange={this.changeProfile}
                            >
                                <FormControlLabel value={profileTypes.designated} control={<Radio/>}
                                                  label={profileTypes.designated}/>
                                <FormControlLabel value={profileTypes.at} control={<Radio/>} label={profileTypes.at}/>
                                <FormControlLabel value={profileTypes.radar} control={<Radio/>}
                                                  label={profileTypes.radar}/>
                            </RadioGroup>
                        </div>
                    )}

                    {
                        renderIf(this.state.showPlate)(
                            <div className={'componentDiv'}>
                                <FormLabel className={'formTitle carsTitle'}>{formTitles.plates}</FormLabel>

                                <div className={'addPlate'}>
                                    <div className={'textInput'}>
                                        <TextField
                                            maxLength={7}
                                            onKeyPress={this.findCar}
                                            label={labels.newPlate}
                                            value={this.getLicensePlateFromState()}
                                            onChange={this.changePlate}
                                            error={this.state.plateError}
                                            margin="normal"
                                        />
                                        <FormHelperText error={this.state.plateError} className="plateErrorMessage">{this.state.plateErrorMessage}</FormHelperText>
                                    </div>


                                    <div className={'plusBtn'} >
                                        <Button variant="fab" color="primary" mini={true} onClick={this.addCar}>
                                            <AddIcon />
                                        </Button>
                                    </div>
                                </div>
                                <List>
                                    {this.generatePlates()}
                                </List>
                            </div>
                        )
                    }

                    <div className={'buttonsDiv'}>
                        <Button variant="contained" color="secondary" onClick={this.cancel}>
                            {labels.cancel}
                        </Button>
                        {renderIf(this.verifyIfCanSave())(
                            <Button variant="contained" color="primary" onClick={this.saveUser}>
                                {labels.save}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default UserControl;


// WEBPACK FOOTER //
// ./src/containers/userControl/userControl.js